import Vue from "vue";
import Vuelidate from "vuelidate";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "@/i18n";
import helpers from "@/plugins/helpers";
import VueSweetalert2 from "vue-sweetalert2";
import VueResource from "vue-resource";
import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import moment from "moment-timezone";
moment.tz.setDefault("Asia/Kuala_Lumpur");
Object.defineProperty(Vue.prototype, "$moment", { value: moment });
import numeral from "numeral";
import './registerServiceWorker'
Object.defineProperty(Vue.prototype, "$numeral", { value: numeral });

Vue.config.productionTip = process.env.NODE_ENV === "production" || false;

Vue.use(Vuelidate);
Vue.use(VueSweetalert2);
Vue.use(VueResource);
Vue.use(datePicker);
Vue.use(helpers, { $swal: Vue.swal, $moment: moment, $router: router, $store: store, $i18n: i18n });

router.beforeEach((to, from, next) => {
  if (
    to.matched.some(record => {
      return record.meta.requiredLoggedIn;
    })
  ){
    if (!store.getters.isLoggedIn) {
      next({ path: ""});
      return;
    } else {
      next ()
    }
  }else if (
    to.matched.some(record => {
      return record.meta.beforeLogIn;
    })
  ){
    if(store.getters.isLoggedIn){
      next({ path: ""});
      return;
    }else{
      next()
    }
  } else {
    next();
  }

  
})

i18n.locale = store.state.user.language;

new Vue({
  router,
  store,
  i18n,
  watch: {
    '$store.getters.language': function(newLanguage) {
      // Update the title when language changes
      document.title = this.$store.getters.getMetaTitles;
    }
  },
  mounted() {
    // Update the title when the component is mounted
    document.title = this.$store.getters.getMetaTitles;
  },
  render: h => h(App)  
}).$mount("#app");
